<template>
    <v-container style="width: 95%;max-width: 95%;">
        <!-- Result Tabs -->
        <Tabs :tab_item_selected="current_tab" @switch-tab="switchTab" :tab_items="tabs" />

        <!-- Spinner -->
        <!--<v-row justify="center" align="center" style="margin-top:10px;">
            <div id="results-loading" v-html="store.getters.getProcessState('load-results')"></div>
        </v-row>-->

        <!-- Table Tab -->
        <div id="result-table" v-if="current_tab == 'results'">

            <div v-if="Object.keys(store.getters.snvs).length > 0 || (store.getters.ag_grid_getrowdata).length > 0"
                class="table-section">
                <p class="table-title">Single Nucleotide Variants (SNVs)</p>
                <Table_SNV :preferSelected="false" :showSelectColumn="true" :usePatientData="false"
                    :maxHeight="0" table_id="results_snv_table"/>
            </div>

            <div v-if="Object.keys(store.getters.indels).length > 0" class="table-section">
                <p class="table-title">Insertions and Deletions (InDels)</p>
                <Table_InDel table_id="results_indel_table" :showSelectColumn="true" />
            </div>

            <div v-if="Object.keys(store.getters.fusions).length > 0" class="table-section">
                <p class="table-title">Gene Fusions</p>
                <Table_Fusion table_id="results_fusion_table" :showSelectColumn="true" />
            </div>

            <div v-if="Object.keys(store.getters.genes).length > 0" class="table-section">
                <p class="table-title">Genes</p>
                <Table_Gene table_id="results_gene_table" :showSelectColumn="true"/>
            </div>

            <div v-if="Object.keys(store.getters.unidentified).length > 0" class="table-section">
                <p class="table-title">Unidentified</p>
                <Table_Unidentified table_id="results_unidentified_table" :showSelectColumn="true" />
            </div>

        </div>

        <!-- Treatments Table -->
        <div v-show="current_tab == 'treatments'">
            <p class="table-title" ref="treatments">
                Treatments
            </p>
            <Table_Treatments_AllVariants></Table_Treatments_AllVariants>
            <div style="height:20px;"></div>
        </div>

        <div v-if="!store.getters.getProcessState('load-results')" style="margin-bottom:40px;">
                <v-row>
                    <v-col cols="12" md="12" lg="12" xl="12" style="">
                        <div class="download-buttons" style="text-align:right;">
                            <span class="table-title">Download Results</span>
                            <select style="margin-left:20px; margin-right: 20px;" v-model="chosen_download_type">
                                <option value="variants">Variants</option>
                                <option value="treatments">Treatments</option>
                            </select>
                            <v-btn style="margin-right: 20px;" class="text-button download-button" @click="downloadResults()">
                                <v-icon icon="mdi-file-delimited-outline" size="1rem" />
                                    &nbsp;Save
                            </v-btn>
                            <v-btn class="text-button download-button" @click="toggleConfigButton">
                                <v-icon :icon="configure_window_open ? 'mdi-chevron-up' : 'mdi-chevron-down'" size="1.5rem" />
                                Configure
                            </v-btn>
                        </div>
                        <div class="download-configure" v-if="configure_window_open">
                            <b>Select properties to include in the export:</b>
                            <div class="download-configure-grid">
                                <div
                                    v-for="item in (chosen_download_type == 'variants' ? download_properties_variants : download_properties_treatments)"
                                    :key="item.title">
                                    <input type="checkbox" class="download-checkbox" :checked="item.checked"
                                        :disabled="item.mutable === false"
                                        @change="item.checked = !item.checked" />&nbsp;<label>{{ item.title }}</label>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
        </div>

        <!-- Plots -->
        <div v-show="current_tab == 'results'" v-if="store.getters.showSNVPlots">
            <div style="margin-top:20px;"></div>
            <v-divider></v-divider>
            <!--<p class="table-title" ref="graph">
                Graphs
            </p>-->
            <Biomarker_Plots></Biomarker_Plots>
        </div>

    </v-container>
</template>

<script setup lang="js">
import { ref, onMounted, computed, watch, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import axios from 'axios';
import Table_Gene from '@/components/tables/Table_Gene.vue';
import Table_Unidentified from '@/components/tables/Table_Unidentified.vue';
import Table_SNV from '@/components/tables/Table_SNV.vue';
import Table_Fusion from '@/components/tables/Table_Fusion.vue';
import Table_InDel from '@/components/tables/Table_InDel.vue';
import Biomarker_Plots from "@/components/plot/Biomarker_Plots";
import variant_annotation from "@/methods/variant_annotation";
import Plotly from '@/assets/js/plotly-latest.min.js';
import Ideogram from 'ideogram';
import file_download from '@/methods/file_download';
import Tabs from '@/components/basic_components/Tabs.vue';
import Table_Treatments_AllVariants from '@/components/tables/Table_Treatments_AllVariants.vue'

const store = useStore();
const route = useRoute();

const is_loading = ref(false);
const sunburst = ref(0);
const current_tab = ref('results');
const configure_window_open = ref(false);
const chosen_download_type = ref('variants');
const data_all_pathogencity_radar = ref("");
const data_all_treatments_sunburst = ref("");
const results_loaded = computed(() => store.getters.resultsLoaded);
const last_query = computed(() => store.state.last_query);
const tabs = ref([{name: 'Results', id: 'results'},{name: 'Treatments', id: 'treatments'}]);
const el = ref(null);

/**
 * This ref holds a list of properties that can potentially be retrieved for variants.
 * Each entry should have four attributes: A title for the frontend, an internal ID (will be printed in resulting CSV),
 * the according path to find it in the server object, and whether it is initially enabled.
 * mutable: false can be set to disable checkbox interaction for the user.
 */
const download_properties_variants = ref([
    { title: 'Gene (HGNC)', id: 'gene_hgnc', path: 'UTA_Adapter.gene_name', checked: true, mutable: false },
    { title: 'Variant (Gen.)', id: 'variant_g', path: 'UTA_Adapter.input_data', checked: true, mutable: false },
    { title: 'Variant (Tr.)', id: 'variant_t', path: 'UTA_Adapter_gene.aminoacid_exchange', checked: true },
    { title: 'Transcript (NCBI)', id: 'transcript_ncbi', path: 'UTA_Adapter.transcript', checked: true },
    { title: 'Transcript (Ens.)', id: 'transcript_ens', path: 'gencode_genomic.MANE_Select_transcript', checked: true },
    { title: 'Protein ID (NCBI)', id: 'protein_id', path: 'UTA_Adapter_protein_sequence.protein_id', checked: true },
    { title: 'UniProt ID', id: 'uniprot_id', path: 'alphamissense.uniprot_id', checked: true },
    { title: 'Gene (Ens.)', id: 'gene_ens', path: 'gencode_genomic.gene[0].gene_id', checked: true },
    { title: 'Gene Type', id: 'gene_type', path: 'gencode_genomic.gene[0].gene_type', checked: true },
    { title: '1000Genomes AC', id: '1000g_ac', path: 'dbnsfp.1000Gp3_AC', checked: true },
    { title: '1000Genomes AF', id: '1000g_af', path: 'dbnsfp.1000Gp3_AF', checked: true },
    { title: 'ALFA Total AC', id: 'alfa_total_ac', path: 'dbnsfp.ALFA_Total_AC', checked: true },
    { title: 'ALFA Total AF', id: 'alfa_total_af', path: 'dbnsfp.ALFA_Total_AF', checked: true },
    { title: 'AlphaMissense Score', id: 'alphamissense.score', path: 'alphamissense.score', checked: true },
    { title: 'AlphaMissense Class', id: 'alphamissense.class', path: 'alphamissense.alphamissense_class', checked: true },
    { title: 'CADD Score', id: 'cadd', path: 'dbsnfp.CADD_raw', checked: true },
    { title: 'CIViC (# of exact matches)', id: 'civic_exact', path: 'civic.civic_features_norm.exact_match', checked: true },
    { title: 'CIViC (# of nearby mut.)', id: 'civic_nearby', path: 'civic.civic_features_norm.nearby_mutations', checked: false },
    { title: 'ClinVar Estimation', id: 'clinvar_estim', path: 'clinvar.CLNSIG', checked: true },
    { title: 'ClinVar Review Status', id: 'clinvar_rev', path: 'clinvar.CLNREVSTAT', checked: true },
    { title: 'ClinVar Cancer Type', id: 'clinvar_cancer', path: 'clinvar.CLNDN', checked: false },
    { title: 'ClinVar ID', id: 'clinvar_id', path: 'clinvar.CLINVARID', checked: true },
    { title: 'dbSNP Pop. Frequency', id: 'dbsnp_freq', path: 'dbsnp.freq_total', checked: false },
    { title: 'dbSNP rsID', id: 'dbsnp_rsid', path: 'dbsnp.rsID', checked: true },
    { title: 'ExAC AC', id: 'strand', path: 'dbnsfp.ExAC_AC', checked: true },
    { title: 'ExAC AF', id: 'strand', path: 'dbnsfp.ExAC_AF', checked: true },
    { title: 'FATHMM-MKL', id: 'fathmm_mkl', path: 'dbnsfp.fathmm-MKL_coding_score', checked: true },
    { title: 'FATHMM-XF', id: 'fathmm_xf', path: 'dbnsfp.fathmm-XF_coding_score', checked: true },
    { title: 'GERP++ Score', id: 'gerp++', path: 'dbnsfp.GERP++_RS', checked: false },
    { title: 'gnomAD AC', id: 'gnomad_ac', path: 'gnomAD_exomes_AC', checked: true },
    { title: 'gnomAD AF', id: 'gnomad_af', path: 'gnomAD_exomes_AF', checked: true },
    { title: 'LoFtool', id: 'loftool', path: 'loftool.Score', checked: true },
    { title: 'MetaLR Score', id: 'metalr', path: 'dbnsfp.MetaLR_Score', checked: true },
    { title: 'MetaKB (# of exact matches)', id: 'metakb_exact', path: 'metakb.metakb_features_norm.exact_match', checked: true },
    { title: 'MetaKB (# of any mut. in gene)', id: 'metakb_any', path: 'metakb.metakb_features_norm.any_mutation_in_gene', checked: false },
    { title: 'MetaSVM Score', id: 'metasvm', path: 'dbnsfp.MetaSVM_Score', checked: true },
    { title: 'MutationAssessor Score', id: 'mutation_assessor', path: 'dbnsfp.MutationAssessor_score', checked: true },
    { title: 'MutationTaster Score', id: 'mutation_taster', path: 'dbnsfp.MutationTaster_score', checked: true },
    { title: 'MVP Score', id: 'mvp', path: 'mvp.Score', checked: true },
    { title: 'Onkopus (# of total matches)', id: 'onkopus_matches', path: 'onkopus_aggregator.meta.total_number_of_results_merged_all_match_types', checked: true },
    { title: 'phastCons 17way Primate', id: 'phatconst_17way', path: 'dbnsfp.phastCons17way_primate', checked: true },
    { title: 'phyloP 17way Primate', id: 'phylop_17way', path: 'dbnsfp.phyloP17way_primate', checked: true },
    { title: 'Polyphen2 HDiv (agg.)', id: 'pp2_hdiv_agg', path: 'dbnsfp.Polyphen2_HDIV_score_aggregated_value', checked: true },
    { title: 'Polyphen2 HDiv (pred.)', id: 'pp2_hdiv_pred', path: 'dbnsfp.Polyphen2_HDIV_pred_formatted', checked: true },
    { title: 'Polyphen2 HVar (agg.)', id: 'pp2_hvar_agg', path: 'dbnsfp.Polyphen2_HVAR_score_aggregated_value', checked: true },
    { title: 'Polyphen2 HVar (pred.)', id: 'pp2_hvar_pred', path: 'dbnsfp.Polyphen2_HVAR_pred_formatted', checked: true },
    { title: 'PrimateAI', id: 'primateai', path: 'primateai.Score', checked: true },
    { title: 'REVEL Score', id: 'revel', path: 'revel.Score', checked: true },
    { title: 'SIFT Score', id: 'sift_score', path: 'dbnsfp.SIFT_score', checked: true },
    { title: 'SIFT Prediction', id: 'sift_pred', path: 'dbnsfp.SIFT_pred', checked: true },
    { title: 'VUSPredict', id: 'vuspredict', path: 'vus_predict.Score', checked: true },
    { title: 'Chromosome', id: 'chromosome', path: 'UTA_Adapter_gene.chromosome', checked: false },
    { title: 'Position (hg38)', id: 'pos_hg38', path: 'variant_data.POS_hg38', checked: false },
    { title: 'Position (hg19)', id: 'pos_hg19', path: 'variant_data.POS_hg19', checked: false },
    { title: 'Ref. Allele', id: 'allele_ref', path: 'variant_data.REF', checked: false },
    { title: 'Alt. Allele', id: 'allele_alt', path: 'variant_data.ALT', checked: false },
    { title: 'Genomic Loc.', id: 'genomic_location', path: 'UTA_Adapter_gene.results_string', checked: false },
    { title: 'AA exchange', id: 'aa_exchange', path: 'UTA_Adapter.variant_exchange', checked: false },
    { title: 'AA exchange (long)', id: 'aa_exchange_long', path: 'UTA_Adapter.variant_exchange_long', checked: false },
    { title: 'cDNA', id: 'cdna', path: 'UTA_Adapter_gene.c_dna_string', checked: false },
    { title: 'CDS start', id: 'cds_start', path: 'UTA_Adapter_gene.cds_start', checked: false },
    { title: 'CDS end', id: 'cds_end', path: 'UTA_Adapter_gene.cds_end', checked: false },
    { title: 'Protein Loc.', id: 'protein_location', path: 'UTA_Adapter_gene.prot_location', checked: false },
])
/**
 * Same as the ref above, but for treatments.
 */
const download_properties_treatments = ref([
    { title: 'Variant', id: 'variant', path: 'biomarker', checked: true, mutable: false },
    { title: 'Match Type', id: 'match_type', path: 'match_type', checked: true, mutable: false },
    { title: 'Disease', id: 'disease', path: 'disease', checked: true, mutable: false },
    { title: 'Drug', id: 'drug_name', path: 'drug_name', checked: true, mutable: false },
    { title: 'Drug Class', id: 'drug_class', path: 'drug_class', checked: true },
    { title: 'Evidence Level', id: 'evidence_level', path: 'evidence_level_onkopus', checked: true },
    { title: 'Response', id: 'response', path: 'response', checked: true },
    { title: 'Source', id: 'source', path: 'source', checked: true },
    { title: 'Citation ID', id: 'citation_id', path: 'citation_id', checked: true },
    { title: 'Citation URL', id: 'citation_url', path: 'citation_url', checked: false },
    { title: 'Evidence Statement', id: 'evidence_statement', path: 'evidence_statement', checked: false },
]);

/**
 * @emit close-tooltip - Closes any active tooltip windows.
 */
const emit = defineEmits(['close-tooltip']);

/**
 * Converts server results to a CSV file and downloads it.
 */
const downloadResults = async () => {
    let reqID = ""
    if (store.getters.getIDData === undefined) {
        reqID = route.query.q
    } else {
        reqID = store.getters.getIDData
    }
    if (chosen_download_type.value == 'variants')
        await file_download.convertJSONToCSV(store.getters.snvs, download_properties_variants.value.filter((item) => item.checked), ",").then((result) => {
            file_download.downloadCSV(result, reqID + "_onkopus_variants");
        });
    else
        await file_download.convertTreatmentsToCSV(store.getters.snvs, download_properties_treatments.value.filter((item) => item.checked), 3, ",").then((result) => {
            file_download.downloadCSV(result, reqID + "_onkopus_treatments");
        });
}

const redrawPlot = (graphJSON,element) => {
    //data_all_treatments_sunburst.value = graphJSON
    const dataTreatmentsSunburst1 = Object.assign({},graphJSON)
    var layout = { width: 400, height: 350, margin: { l: 10, r: 10, b: 10, t: 10, pad: 5 } }
    try {
                //this.dataTreatmentsSunburst1 = graphJSON
                var layout = { width:400, height:350, margin: { l:10,r:10,b:10,t:10, pad:5 } }
                //graphJSON["layout"] = {}
                graphJSON["layout"]["width"] = 420
                graphJSON["layout"]["height"] = 350
                graphJSON["layout"]["paper_bgcolor"] ="#ffffff"

                //alert(JSON.stringify(graphJSON))
                Plotly.plot(element+'-thumb',dataTreatmentsSunburst1,graphJSON);

                const dataTreatmentsSunburst2 = JSON.parse(JSON.stringify(graphJSON))
                dataTreatmentsSunburst2["layout"]["width"] = 1200
                dataTreatmentsSunburst2["layout"]["height"] = 800
                Plotly.plot(element,dataTreatmentsSunburst2,graphJSON);
    } catch (err) {
        console.log(err)
    }
}

const scrollMeTo = (refName) => {
    //alert(el.value[refName])
    //el.value[refName].scrollIntoView({behavior: "smooth"});
    //el.scrollIntoView({ behavior: 'smooth'})
}

const redrawPathogenicityPlot = (graphJSON) => {
    data_all_pathogencity_radar.value = graphJSON
    var layout = { autosize: false, width: 200, height: 200, margin: { l: 20, r: 20, b: 20, t: 20, pad: 0 } }

    try {
        if (graphJSON != undefined) {
            if (graphJSON.constructor == Object) {
                if (!("layout" in graphJSON)) {
                    graphJSON["layout"] = {}
                }
                graphJSON["layout"]["width"] = 500
                graphJSON["layout"]["height"] = 320
                Plotly.plot('chart-pathogenicity-1-thumb', data_all_pathogencity_radar.value, {});

                graphJSON["layout"]["width"] = 1700
                graphJSON["layout"]["height"] = 800
                Plotly.plot('chart-pathogenicity-1', data_all_pathogencity_radar.value, {});
            }
        }
    } catch(error) {
        console.log("Error generating pathogenicity plot: "+error)
    }
}

const redrawChromosomePlot = (graphJSON) => {
    try {
        new Ideogram(
            {
                organism: "human",
                container: '#ideo-container-thumb',
                showBandLabels: false,
                annotations: graphJSON
            }
        )
        // Ideogram enlarged plot
        new Ideogram({
            organism: 'human',
            container: '#ideo-container',
            showBandLabels: true,
            annotations: graphJSON
        })
    } catch (err) {
        console.log("Error generating ideogram plot " + err.message)
    }
}

const generateGeneNameLocations = () => {
    for (let key in store.getters.getVariants) {
        if ("UTA_Adapter" in store.getters.getVariants[key]) {
            let gene_name = store.getters.getVariants[key]["UTA_Adapter"]["gene_name"] + ":" + store.getters.getVariants[key]["UTA_Adapter"]["variant_exchange"]
            store.dispatch('setGeneNameLoc', [gene_name, key])
        }
    }
}

const drawPlots = async () => {
    //if (Object.keys(store.getters.snvs).length > 0) {
    //alert("get plots")

    // Generate chromosome plot
    let url = store.getters.getPathVariable('methods_generate_plot')
    let formData = new FormData();
    formData.append("plot", "chromosome-positions");
    //alert(store.getters.requestID)
    formData.append("request_id", store.getters.requestID)
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            if (store.getters.requestID.localeCompare('')==0) {
                formData.append("variant_data", JSON.stringify(store.getters.getVariants))
            }
        }
    formData.append("genome_version", store.getters.getGenomeVersion)
    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = true;

        var response_data = response.data
        store.dispatch("setProcessState", ["load-patho-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        data_all_pathogencity_radar.value = "";
        var graphJSON = response.data
        redrawChromosomePlot(response_data)
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])

        is_loading.value = false;
    })


    // Generate pathogenicity plot
    /*url = store.getters.getPathVariable('methods_generate_plot')
    formData = new FormData();
    formData.append("plot", "pathogenicity-scores-radar-set");
    formData.append("request_id", store.getters.requestID)
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    if (route.params.id != null) {
        formData.append("pid", route.params.id)
    }
    await axios.post(url, formData, {
      headers: {
        "Content-Type": "text/html"
      }
    }).then((response) => {
                is_loading.value = true;
                var response_data = response.data
                store.dispatch("setProcessState",["load-patho-1-thumb","<div>" + response_data + "</div>"])
                sunburst.value += 1;
                data_all_pathogencity_radar.value = ""
                var graphJSON = response.data
                //alert(JSON.stringify(graphJSON))
                redrawPathogenicityPlot(graphJSON)
                store.dispatch('setProcessState', [ "load-patho-1-thumb", ""])
                is_loading.value = false;
            })
    */

    // Generate clinical significance sunburst plot
    url = store.getters.getPathVariable('methods_generate_plot')
    formData = new FormData();

    // graph1
    formData.append("plot", "treatments-all-drug-class-drugs");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-1')
        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph2
    formData = new FormData();
    formData.append("plot", "treatments-all-cancer-type");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-2')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph3
    formData = new FormData();
    //formData.append("plot", "treatments-all-sunburst-match-type-drug-classes-all");
    formData.append("plot", "treatments-all-sunburst-match-type-drug-classes-all");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-3')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph4
    formData = new FormData();
    formData.append("plot", "treatments-all-sunburst-match-type-drugs-all");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-4')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph5
    formData = new FormData();
    formData.append("plot", "treatments-all-sunburst-response-type");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;

        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-5')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph6
    formData = new FormData();
    formData.append("plot", "treatments-all-patient-match-type-drug-classes");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-6')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph7
    formData = new FormData();
    formData.append("plot", "treatments-all-patient-cancer-type");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-7')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph8
    formData = new FormData();
    formData.append("plot", "treatments-all-patient-drug-class");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-8')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

    // graph9
    formData = new FormData();
    formData.append("plot", "treatments-all-patient-drugs");
    //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
    formData.append("request_id", store.getters.requestID)
    if (route.params.id != null) {
            formData.append("pid", route.params.id)
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

    await axios.post(url, formData, {
        headers: {
            "Content-Type": "text/html"
        }
    }).then((response) => {
        is_loading.value = false;
        var response_data = response.data
        store.dispatch("setProcessState", ["load-sunburst-1-thumb", "<div>" + response_data + "</div>"])
        sunburst.value += 1;
        var graphJSON = response.data
        redrawPlot(graphJSON,'chart-sunburst-set-9')

        store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
        store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])
        store.dispatch('setProcessState', ["load-results", ''])
    })

}

const toggleConfigButton = () => {
    configure_window_open.value = !configure_window_open.value;
}

onBeforeMount(async () => {
    store.dispatch('setProcessState', ["load-patho-1", ""])
    store.dispatch('setProcessState', ["load-patho-1-thumb", ""])
    store.dispatch('setProcessState', ["load-sunburst-1", ""])
    store.dispatch('setProcessState', ["load-sunburst-1-thumb", ""])
})

onMounted(async () => {
    store.dispatch('setBackRef', route.fullPath)
    store.dispatch('setIdData', route.params.id)
    store.dispatch('setShowSNVPlots', false)

    // Search request
    if (route.query.q && last_query.value != route.query.q) {
        store.dispatch('setLastOnkopusQuery', route.query.q);
        store.dispatch('setProcessState', ['load-sunburst-1-thumb', '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-results", '<table style="margin:20px;"><tr><td><div class="spinner-border" role="status"><span class="visually-hidden" style="font-size:16px;">Loading...</span></div></td></tr><tr><td style="font-size:14px;">Loading...</td></tr></table>'])
        store.dispatch('setProcessState', ['load-genompos-1-thumb', '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])

        let query = route.query.q
        if (route.query.genome_version) {
            store.dispatch('setGenomeVersion', route.query.genome_version)
        }

        let oncokb_key = ""
        if (localStorage.getItem("oncokbKey") === null) {
            oncokb_key = ""
        } else {
            oncokb_key = localStorage.getItem("oncokbKey")
        }
        oncokb_key = store.getters.oncokbKey

        await variant_annotation.startRequestVariantList(query, store.getters.getGenomeVersion, oncokb_key)
        store.dispatch('setQuery', route.query.q)
        store.dispatch('setBackRef', route.fullPath)
    }
    // Upload file request
    else if (route.params.id != null) {

        store.dispatch('setProcessState', ['load-sunburst-1-thumb', '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])
        store.dispatch('setProcessState', ["load-results", '<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>'])
        store.dispatch('setProcessState', ['load-genompos-1-thumb', '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'])

        //await variant_annotation.analyzeVariantsSequential(route)
        await variant_annotation.analyzeVariantsParallel(route)

        store.dispatch('setBackRef', route.fullPath)
    }

    generateGeneNameLocations()

    if (Object.keys(store.getters.snvs).length > 0) {

        let url = store.getters.getPathVariable('methods_generate_plot')
        let formData = new FormData();

        // Generate chromosome plot
        /*
        formData.append("plot", "chromosome-positions");

        if (route.params.id != null) {
            formData.append("pid", route.params.id)
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        } else {
            formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }

        formData.append("genome_version", store.getters.getGenomeVersion)

        await axios.post(url, formData, {
            headers: {
                "Content-Type": "text/html"
            }
        }).then((response) => {
            is_loading.value = true;

            // Biomarker pathogenicity plot
            var response_data = response.data
            store.dispatch("setProcessState", ["load-patho-1-thumb", "<div>" + response_data + "</div>"])
            sunburst.value += 1;
            data_all_pathogencity_radar.value = "";
            var graphJSON = response.data

            redrawChromosomePlot(response_data)
            store.dispatch('setProcessState', ["load-genompos-1-thumb", ""])

            is_loading.value = false;
        })*/

        // Generate biomarker pathogenicity plot
        /*url = store.getters.getPathVariable('methods_generate_plot')
        formData = new FormData();
        formData.append("plot", "pathogenicity-scores-radar-set");

        if (route.params.id != null) {
            formData.append("pid", route.params.id)
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        } else {
            //formData.append("variant_data", JSON.stringify(store.getters.getVariants))
        }
        await axios.post(url, formData, {
            headers: {
                "Content-Type": "text/html"
            }
        }).then((response) => {
            is_loading.value = true;

            // Biomarker pathogenicity plot
            var response_data = response.data
            store.dispatch("setProcessState", ["load-patho-1-thumb", "<div>" + response_data + "</div>"])
            sunburst.value += 1;
            data_all_pathogencity_radar.value = ""
            var graphJSON = response.data
            redrawPathogenicityPlot(graphJSON)
            store.dispatch('setProcessState', ["load-patho-1-thumb", ""])

            is_loading.value = false;
        })*/

        //drawPlots()
    } else {
        store.dispatch('setShowSNVPlots', false)
        //store.dispatch('setProcessState', [  "load-results",'' ] )
    }
})

const switchTab = (tab_id) => {
    current_tab.value = tab_id;
    scrollMeTo(tab_id)
}

watch(() => results_loaded.value, (new_count, _) => {
    if (new_count === true) {
        if (Object.keys(store.getters.snvs).length > 0) {
            drawPlots()
            store.dispatch('setShowSNVPlots', true)
        } else {
            store.dispatch('setProcessState', ["load-results", ""])
        }
    }
})
</script>

<style>
.table-variants tr>td:first-child {
    border: 1px solid #dddddd;
}

.tb-variants-col {
    padding: 10px;
}

.tb-variants-col:hover {
    background-color: #FFFFFF;
}

.mdi-arrow-up-thin:hover {
    color: #3498db;
}

.mdi-arrow-down-thin:hover {
    color: #3498db;
}

a.router-link-active {
    border-bottom: 1px solid 3498db;
}

.flip_bar {
    -moz-transform: scale(-1, 1);
    -webkit-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    -ms-transform: scale(-1, 1);
    transform: scale(-1, 1);
}

.download-results-bar {
    margin: 20px;
    padding: 10px;
    width: 100%;
    text-align: left;
}

.display-button {
    display: block;
}
</style>

<style scoped>
#result-table {
    width: 100%;
}

.table-title {
    font-size: var(--font-600);
    font-family: var(--default-font);
    text-align: left;
    font-weight: 300;
}

.table-section {
    margin-bottom: 40px;
}

.download-buttons {
    display: grid;
    grid-auto-flow: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.download-buttons>select {
    background-color: var(--light-grey);
    padding: 10px 5px 5px 5px;
    -moz-appearance: menulist;
    box-shadow: var(--stronger-shadow);
    text-align: center;
    border-radius: 10px;
    width: max-content;
}

.download-button {
    box-shadow: var(--stronger-shadow);
    text-align: center;
    padding: 4px 10px;
    border-radius: 10px;
}

.download-button:hover {
    color: var(--dark-grey)
}

.download-configure {
    margin: auto;
    max-width: 90%;
    border: var(--dark-grey) solid 1px;
}

.download-configure-grid {
    width: 100%;
    margin: 16px;
    min-height: 100px;
    display: grid;
    column-gap: 16px;
    grid-template-rows: repeat(auto-fill, 2.5ch);
    grid-template-columns: repeat(4, 1fr);
    justify-content: space-evenly;
    text-align: left;
    align-items: center;
}

.download-checkbox {
    accent-color: var(--default-blue);
}

@media (max-width: 1000px) {

.text-button {
    font-size: 0.7rem !important;
}

.download-buttons>select {
    font-size: 0.7rem;
}

.download-configure-grid {
    grid-template-columns: repeat(3, 1fr);
}

}

@media (max-width: 750px) {

.download-configure-grid {
    grid-template-columns: repeat(2, 1fr);
}

}

@media (max-width: 600px) {

.download-configure-grid {
    grid-template-columns: repeat(1, 1fr);
}

}

</style>